<template>
    <div class="splide card-slider-async" :data-splide="JSON.stringify(config.splideOptions)">
        <div class="splide__track pt-3">
            <ul class="splide__list">
                <li v-for="slide in slides" class="splide__slide">
                    <div :class="[
                        'card',
                        'h-100',
                        'position-relative',
                        'overflow-hidden',
                        'text-bg-' + styles.cardColorClass,
                        config.cardClass
                    ]">
                    <img v-if="config.showImage" :alt="slide.label" :src="slide.image" class="position-absolute top-0 start-0 w-100 h-100 z-2">
                    <div class="backdrop position-absolute top-0 start-0 w-100 h-100 z-2"
                        :style="{
                        '--backdrop-bg-color': `var(--bs-${styles.backdropColor})`,
                        '--backdrop-opacity': styles.backdropOpacity,
                        '--backdrop-hover-opacity': styles.backdropHoverOpacity,
                        }"
                    ></div>
                        <div :class="['card-body ', 'position-relative', 'd-flex', 'w-100', 'h-100', 'z-3', config.cardContentWrapper]"
                            :style="{'--card-body-hover-color': styles.hoverColor}">
                            <div class="my-auto">
                                <h5 :class="[
                                    config.cardHeadlineClass,
                                    { 'text-truncate': config.cardHeadlineTruncate }
                                ]">
                                    {{ slide.title }}
                                </h5>
                                <div :class="[
                                    'flex-grow-1',
                                    config.cardCopyClass,
                                    config.showButton ? 'mb-3' : ''
                                    ]">
                                    <p v-if="slide.city && config.showCity" class="mb-0">
                                        <i v-if="config.showIcons" :class="['fas', 'fa-map-marker', config.iconClass]"></i>
                                        {{ slide.city }}
                                    </p>
                                    <p v-if="slide.type && config.showType" class="mb-0">
                                        <i v-if="config.showIcons" :class="['fas', 'fa-clock', config.iconClass]"></i>
                                        {{ slide.type }}
                                    </p>
                                    <p v-if="slide.contract && config.showContract" class="mb-0">
                                        <i v-if="config.showIcons" :class="['fas', 'fa-suitcase', config.iconClass]"></i>
                                        {{ slide.contract }}
                                    </p>
                                </div>
                                <button v-if="config.showButton"
                                    :class="[
                                        'btn',
                                        !content.btnType ? 'btn-' + (styles.btnColor === 'none' ? 'link' : styles.btnColor) : '',
                                        content.btnType ? 'btn-outline-' + (styles.btnColor === 'none' ? 'link' : styles.btnColor) : '',
                                        config.btnClass || ''
                                    ]"
                                >
                                    {{ content.btnText || 'Jetzt bewerben!' }}
                                </button>
                                <a class="stretched-link"
                                    :href="slide.url" 
                                    :target="content.target?.includes('targetBlank') ? '_blank' : null"
                                    :rel="content.target?.includes('targetBlank') ? 'noopener noreferrer' : null"
                                    ></a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped>
.backdrop{
  background-color: var(--backdrop-bg-color);
  opacity: var(--backdrop-opacity);
}
.card:hover .backdrop{
    opacity: var(--backdrop-hover-opacity);
}
.card:hover .card-body{
    color: var(--card-body-hover-color);
}
</style>

<script lang="ts" setup>

import axios from "axios";
import { ref, onMounted } from "vue";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

interface Props {
    config: Object
    content: Object
    styles: Object
    apiUrl: string
}

interface Slide {
    image: string
    label: string
    city: string
    title: string
    contract: string | null
    type: string | null
    url: string
}

const props = defineProps<Props>();

const slides = ref<undefined | Array<Slide>>();

axios.get(props.apiUrl)
    .then(response => {
        slides.value = response.data;

    })
    .finally(() => {
        if (slides.value) {
            new Splide('.card-slider-async').mount({ AutoScroll });
        }
    });

</script>
